import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store/store";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { toast } from "react-toastify";

import DescriptionDetailsList from "@/shared/components/DescriptionDetailsList/DescriptionDetailsList";
import { updateExistAppointment } from "@/store/appointments/appointmentsSlice";
import { updateHasVisitedAppointment } from "@/store/schedule/scheduleSlice";
import useUpdateEntity from "@/hooks/useUpdateEntity";
import useGetRole from "@/hooks/useGetRole";

import { ISearchDrawerProps } from "@/shared/interfaces/ui";
import { adminMessage, visitMessage } from "@/utils/constants";

export default function ScheduleAppointmentTitle({
    toggleDrawer,
}: ISearchDrawerProps) {
    const dispatch = useDispatch();
    const appointmentData = useSelector(
        (state: RootState) => state.appointments,
    );
    const {
        startTime,
        endTime,
        duration,
        hasVisited,
        _id,
        isAppointmentComplete,
    } = appointmentData.existtAppointment;

    const { handleUpdate } = useUpdateEntity();
    const { isAdmin } = useGetRole();

    async function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const isChecked = event.target.checked;

        function handleCloseAndUpdate() {
            dispatch(updateHasVisitedAppointment({ _id, isChecked }));
            dispatch(updateExistAppointment({ hasVisited: isChecked }));
            toggleDrawer(false);
        }
        if (isAdmin) {
            if (!isAppointmentComplete) {
                await handleUpdate({
                    entity: "appointments",
                    id: _id,
                    data: { hasVisited: isChecked },
                    onSuccess: handleCloseAndUpdate,
                });
            } else toast.error(visitMessage);
        } else toast.error(adminMessage);
    }

    return (
        <div
            className='edit_drawer_container_time drawer_item'
            style={{
                display: "flex",
                gap: 16,
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 60
            }}
        >
            <DescriptionDetailsList
                title='Час:'
                description={`${startTime} - ${endTime} \u00A0`}
                span={`(${duration} хвилин)`}
                style={{ maxWidth: 210, zIndex:99 }}
            />
            <dl className='ddlist_container1 ' style={{ width: 136, zIndex:99 }}>
                <dt className='ddlist_title1'>{"Візит"}</dt>
                <dd className='ddlist_subtitle1'>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size='small'
                                    checked={hasVisited}
                                    onChange={handleChange}
                                    value='visited'
                                />
                            }
                            label={hasVisited ? "Відбувся" : "Не відбувся"}
                        />
                    </FormGroup>
                </dd>
            </dl>
        </div>
    );
}
